import router from "@/router";

const user = {
    state: {
        isLoggedIn: !!localStorage.getItem("access_token"),
        user: {
            available_tax_offices: [],
            prepaid_card_number: '',
            prepaid_card_status: '',
            prepaid_card_expired_at: null
        },
        bonus: null,
        taxFormConfirmed: false,
        discount: null,
        ranking: null,
        rankingPunctuality: null,
        payoutsHistory: null,
        checkAgreements: {
            message: "",
            result: null,
        },
        showMobileAppAssets: false,
        /**
         * BONUSES BEGIN - Wypłaty premii początek bloku
         * For displaying data in two locations:
         * 1 - In popups reminding about bonus payouts a week before the deadline (AppComponent.vue)
         * 2 - For showing notifications in a popup after adding an invoice (UploadDocumentComponent.vue)
         */
        dates:{
            yearToCheckBonus: 2026,
            period1:{
                registerInvoicesFromTo: 'od <b>01.01.2026&nbsp;r.</b> do <b>30.06.2026&nbsp;r.</b>',//invoice registration dates
                displayPopupAboutPayoutFrom: '2026-07-24',//when to display a popup with a reminder about withdrawing funds
                canPayoutTo: '2026-07-31',//deadline for topping up the prepaid card
                canPayoutToFriendly: '<b>31.07.2026&nbsp;r.</b>',//deadline for topping up the prepaid card firendly
            },
            period2:{
                registerInvoicesFromTo:  'od <b>01.07.2026&nbsp;r.</b> do <b>31.10.2026&nbsp;r.</b>',//invoice registration dates
                displayPopupAboutPayoutFrom: '2026-11-23',//when to display a popup with a reminder about withdrawing funds
                canPayoutTo: '2026-11-30',//deadline for topping up the prepaid card
                canPayoutToFriendly: '<b>30.11.2026&nbsp;r.</b>',//deadline for topping up the prepaid card friendly
            },
            period3:{
                registerInvoicesFromTo:  'od <b>01.11.2026&nbsp;r.</b> do końca edycji.',//invoice registration dates
                displayPopupAboutPayoutFrom: '2027-01-24',//when to display a popup with a reminder about withdrawing funds
                canPayoutTo: '2027-01-31',//deadline for topping up the prepaid card
                canPayoutToFriendly: '<b>31.01.2027&nbsp;r.</b>',//deadline for topping up the prepaid card friendly
            },
        },
        /**
         * BONUSES END - Wypłaty premii koniec bloku
         */

        /**
         * WYSYŁKA ZAMÓWIEŃ ze sklepu Pirelli - info m.i. w Strefie Benefitów/
         * SHIPPING ORDERS from the Pirelli store - information, among others, in the Benefits Zone
         */
        deliveries:{
            period1:{
                from: '2026-08-01',//delivery from
                to:'2026-09-30',//delivery to
                fromToFriendly:'od 01.08.2026&nbsp;r. do&nbsp;30.09.2026&nbsp;r.',//delivery from to friendly
                fromToFriendlyShort:'01.08.2026&nbsp;r. -&nbsp;30.09.2026&nbsp;r.',//delivery from to friendly short
                forOrdersFromTo: 'do 31.07.2026&nbsp;r.'//order dates

            },
            period2:{
                from: '2027-02-01',//delivery from
                to:'2027-03-31',//delivery to
                fromToFriendly:'od 01.02.2027&nbsp;r. do&nbsp;31.03.2027&nbsp;r.',//delivery from to friendly
                fromToFriendlyShort:'01.02.2027&nbsp;r. -&nbsp;31.03.2027&nbsp;r.',//delivery from to friendly short
                forOrdersFromTo: 'od 01.08.2026&nbsp;r. do 31.01.2027&nbsp;r.'//order dates
            }
        }
    },
    mutations: {
        setLoggedIn: function (state, payload) {
            state.isLoggedIn = payload;
        },
        setTaxFormConfirmed: function (state, payload) {
            state.taxFormConfirmed = payload;
        },
        userUpdate: function (state, payload) {
            state.user = { ...state.user, ...payload };
        },
        taxOfficesUpdate: function (state, payload) {
            state.user.available_tax_offices = payload;
            //state.user.available_tax_offices = payload;
        },
        bonusUpdate: function (state, payload) {
            state.bonus = payload;
        },
        discountUpdate: function (state, payload) {
            state.discount = payload;
        },
        rankingUpdate: function (state, payload) {
            state.ranking = payload;
        },
        rankingPunctualityUpdate: function (state, payload) {
            state.rankingPunctuality = payload;
        },
        payoutsUpdate: function (state, payload) {
            state.payoutsHistory = payload;
        },
        agreementsUpdate: function (state, payload) {
            state.checkAgreements = payload;
        },
    },
    actions: {
        login: function (context, payload) {
            return new Promise((resolve, reject) => {
                window.api
                    .post("/login", payload)
                    .then((response) => {
                        localStorage.setItem(
                            "access_token",
                            response.data.data.token
                        );
                        context.commit("setLoggedIn", true);
                        context.dispatch("getUser");
                        router.go(
                            history && history.length > 2
                                ? -1
                                : { name: "home" }
                        );
                        resolve(response);
                    })
                    .catch((e) => {
                        if (e.response.status === 401) {
                            if (localStorage.getItem("access_token")) {
                                localStorage.removeItem("access_token");
                            }
                        }
                        reject(e);
                    });
            });
        },
        getAgreements: async function (context) {
            await window.api
                .get("my-account/check-agreements")
                .then((response) => {
                    context.commit("agreementsUpdate", {
                        message: response.data.message,
                        result: response.data.data.result,
                    });
                    // if (response.data.data.result === 1) {
                    //     sessionStorage.setItem('agreements_accepted', 'true');
                    // }
                })
                .catch((error) => {
                    context.commit("agreementsUpdate", {
                        message: error.response.data.message,
                        result: error.response.data.data.result,
                    });
                });
        },
        logout: function () {
            localStorage.removeItem('access_token');
            sessionStorage.clear();
            delete window.api.defaults.headers.common["Authorization"];
            router.go({ name: "login" });
        },
        getUser: async function (context) {
            await window.api
                .get("my-account/basic-user-data")
                .then((response) => {
                    context.commit("userUpdate", response.data.data);
                })
                .catch(() => {});
        },
        getUserFull: async function (context) {
            await window.api
                .get("my-account/all-user-data")
                .then((response) => {
                    context.commit("userUpdate", response.data.data);
                })
                .catch(() => {});
        },
        getTaxOffices: async function (context) {
            await window.api
                .get("my-account/tax-offices")
                .then((response) => {
                    context.commit("taxOfficesUpdate", response.data.data);
                })
                .catch(() => {});
        },
        getBonusSummary: function (context) {
            window.api
                .get("my-account/bonus-summary")
                .then((response) => {
                    context.commit("bonusUpdate", response.data.data || {});
                })
                .catch(() => {
                    context.commit("bonusUpdate", {});
                });
        },
        getDiscount: function (context) {
            window.api
                .get("my-account/direct-sales-discount")
                .then((response) => {
                    context.commit("discountUpdate", response.data.data || {});
                })
                .catch(() => {
                    context.commit("discountUpdate", {});
                });
        },
        getRanking: function (context) {
            window.api
                .get("my-account/ranking")
                .then((response) => {
                    context.commit(
                        "rankingUpdate",
                        response.data.data || {}
                    );
                })
                .catch(() => {
                    context.commit("rankingUpdate", {});
                });
        },
        getRankingPunctuality: function (context) {
            window.api
                .get("my-account/ranking-punctuality")
                .then((response) => {
                    context.commit(
                        "rankingPunctualityUpdate",
                        response.data.data || {}
                    );
                })
                .catch(() => {
                    context.commit("rankingPunctualityUpdate", {});
                });
        },
        getBonusPayoutsHistory: function (context) {
            window.api
                .get("my-bonuses/bonus-payout-history")
                .then((response) => {
                    context.commit("payoutsUpdate", response.data.data || []);
                })
                .catch(() => {
                    context.commit("payoutsUpdate", []);
                });
        },
        getPrepaidCard: function (context) {
            window.api
                .get("my-bonuses/prepaid-card")
                .then((response) => {
                    context.commit("userUpdate", response.data.data);
                })
                .catch(() => {});
        },
    },
    getters: {
        isLoggedIn: function (state) {
            return !!state.isLoggedIn;
        },
        user: function (state) {
            return state.user;
        },
        dates: function (state) {
            return state.dates;
        },
        deliveries: function (state) {
            return state.deliveries;
        },
        bonus: function (state) {
            return state.bonus;
        },
        discount: function (state) {
            return state.discount;
        },
        ranking: function (state) {
            return state.ranking;
        },
        rankingPunctuality: function (state) {
            return state.rankingPunctuality;
        },
        payoutsHistory: function (state) {
            return state.payoutsHistory;
        },
        checkAgreements: function (state) {
            return state.checkAgreements;
        },
        showMobileApp: function (state) {
            return state.showMobileAppAssets;
        },
        taxFormConfirmed: function (state) {
            return state.taxFormConfirmed;
        },
    },
};

export default user;
